<template>
    <div class="flex">
        <image-button
                @click.native="showModal = true"
                img="/images/svg/ATS3bdSeriesicon_missing.svg">
            interpolate missing values
        </image-button>

        <portal to="modals" v-if="showModal">
            <modal-bottom v-if="showModal" @close="close()" class="bg-grey-lighter">
                <h3 slot="header">Interpolate Missing Values</h3>

                <div slot="save" v-show="action !== null">
                    <a class="cursor-pointer inline-block bg-blue text-white px-4 py-2 rounded" v-show="true"
                       @click="save()">
                        Apply
                    </a>
                </div>

                <!--
                <p class="text-grey-dark text-sm leading-normal">
                                    In order to fill the gaps in time series, numerous
                                    methods are available. In this case<br>

                                    - Interpolate(linear):<br>
                                    reconstruct missing points within the range of a set of known data points<br>
                                    example: A and B are the known data point and there are N missing values within this range
                                    than N+1-equal steps leads from A to B, each step defined as Step1 = ... = StepN+1 = (B-A)/N+1

                                    - Extrapolate(constant):<br>
                                    interpretation of values in tiers to bring all time series selected to the same length.<br>
                                    example: series ONE starts with value A two periods later than series TWO which is two periods shorter than the fist one and ends with value B
                                    so series ONE will be extrapolated twice at the beginning by value A each and series TWO is extrapolated twice at its end by value B
                                </p>
                -->

                <button class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        :class="{'bg-blue-lightest border-blue-dark': action === 'linear'}"
                        @click="toggle('linear');">
                    Interpolate (Linear)
                </button>

                <button class="bg-white cursor-pointer text-center p-4 mr-4 mb-4 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark"
                        :class="{'bg-blue-lightest border-blue-dark': action === 'constant'}"
                        @click="toggle('constant')">
                    Extrapolate (constant)
                </button>
            </modal-bottom>
        </portal>

    </div>
</template>

<script>

    import ImageButton from "../ImageButton";
    import ModalBottom from "../ModalBottom";
    import InterpolateLinearModifier from "../../modifiers/InterpolateLinearModifier";
    import InterpolateConstantModifier from "../../modifiers/InterpolateConstantModifier";

    export default {
        name: "ComputeInterpolation",

        components: {ModalBottom, ImageButton},

        data: () => ({
            showModal: false,
            action: null,
        }),

        computed: {
            times() {
                return this.$store.getters.times;
            },
            selected() {
                return this.$store.state.rawData.data[this.$store.state.periodicity].data.map(function (item, index) {
                    return index;
                });
            },
        },

        watch: {
            action() {
                this.modify()
            },
            showModal() {
                this.action = null;
            },
        },

        methods: {
            toggle(type) {
                this.action = this.action === type ? null : type;
            },
            close() {
                this.$store.dispatch('abort');
                this.showModal = false;
            },
            modify() {
                if (this.action === 'linear') {
                    this.$store.dispatch('setModifier', {
                        modifier: new InterpolateLinearModifier(),
                        ids: this.selected
                    });
                }

                if (this.action === 'constant') {
                    this.$store.dispatch('setModifier', {
                        modifier: new InterpolateConstantModifier(),
                        ids: this.selected
                    });
                }

                if (this.action === null) {
                    this.$store.dispatch('abort');
                }
            },
            save() {
                this.$store.dispatch('save');
                this.showModal = false;
            }
        }
    }
</script>

<style scoped>

</style>
